import { Text } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import { FC } from 'react'

const RoundLegend: FC<{ color: string; label: string }> = ({ color, label }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                mr: 4,
            }}
        >
            <Box
                sx={{
                    width: '16px',
                    height: '16px',
                    borderRadius: '100%',
                    backgroundColor: color,
                    mr: 2,
                }}
            />
            <Text variant={'body3'}>{label}</Text>
        </Box>
    )
}

export const ChartLegend: FC<{ data: { color: string; label: string }[] }> = (legendItems) => {
    const items = legendItems.data.map(({ color, label }, index) => {
        return <RoundLegend color={color} label={label} key={index} />
    })
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                mt: 2,
                flexWrap: 'wrap',
                gap: 1,
                pl: 5,
            }}
        >
            {items}
        </Box>
    )
}

export default ChartLegend
